import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["aria-current"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "step-number"
}
const _hoisted_4 = { class: "text-container" }
const _hoisted_5 = {
  key: 0,
  class: "visually-hidden"
}
const _hoisted_6 = {
  key: 1,
  class: "visually-hidden"
}
const _hoisted_7 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_8 = {
  key: 0,
  class: "contract-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "step-container",
    "aria-current": _ctx.state === _ctx.StepState.active ? 'step' : undefined
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`step-number-container icon step-number-container-${_ctx.state}`),
      "aria-hidden": "true"
    }, [
      (_ctx.state === _ctx.StepState.valid)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "icon",
            src: _ctx.loadIconArrow,
            alt: _ctx.$t('app.step.completed')
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.number), 1))
    ], 2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", {
        class: _normalizeClass(["title", `title-${_ctx.state}`])
      }, [
        (_ctx.state === _ctx.StepState.valid)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('app.step.completed')), 1))
          : _createCommentVNode("", true),
        (_ctx.state === _ctx.StepState.active)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('app.step.current')), 1))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
      ], 2),
      (_ctx.state === _ctx.StepState.valid && _ctx.subtitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", null, _toDisplayString(_ctx.subtitle), 1),
            (_ctx.contractLabel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.contractLabel), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}